import type { MetaSegment, WorldLocation } from "@skv/core";

export enum OpportunitySearchTypes {
  NoLocation,
  LocationSuburb,
  LocationRegional,
  LocationMetro,
  LocationStateRegion,
}

interface OpportunitySearchResultOrganisation {
  friendlyName: string;
  id: number;
  logoUrl: string;
  name: string;
  url: string;
}

export interface OpportunitySearchResult {
  agencyName?: string;
  category: MetaSegment<number>;
  eventEndDate?: string | null;
  eventStartDate?: string | null;
  friendlyName: string;
  id: number;
  isFeatured: boolean;
  isNew: boolean;
  isOrgLinkedEntity: boolean;
  locations: WorldLocation[];
  name: string;
  onlineRemoteVolunteers: boolean;
  organisation: OpportunitySearchResultOrganisation;
  organisationMemberName?: string;
  summary: string;
  typesOfWork: MetaSegment<number>[];
  url: string;
}

export interface OpportunitySearchResults {
  canonicalLocation: string | null;
  canonicalUrl: string;
  metaFilters: string[];
  noLocationMatch: boolean;
  onlineRemoteVolunteersOnly: boolean;
  opportunities: OpportunitySearchResult[];
  opportunitySearchType: OpportunitySearchTypes;
  organisationName: string | null;
  page: number;
  pageDescription: string;
  pageSize: number;
  pageTitle: string;
  searchSummary: string;
  suggestedLocations: MetaSegment[];
  surroundingOpportunityIndex: number;
  totalCount: number;
  totalPages: number;
}

export enum SearchResultStatus {
  IDLE = "IDLE",
  FETCHING_DATA = "FETCHING_DATA",
  FETCH_ERROR = "FETCH_ERROR",
}
